/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { pluginsGetMarketplaceSettings } from "../funcs/pluginsGetMarketplaceSettings.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { MarketplaceSettingsResult } from "../models/components/marketplacesettingsresult.js";
import {
  GetMarketplaceSettingsRequest,
  GetMarketplaceSettingsSecurity,
} from "../models/operations/getmarketplacesettings.js";
import { unwrapAsync } from "../types/fp.js";
export type MarketplaceSettingsQueryData = MarketplaceSettingsResult;

export function prefetchMarketplaceSettings(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetMarketplaceSettingsRequest | undefined,
  security?: GetMarketplaceSettingsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildMarketplaceSettingsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildMarketplaceSettingsQuery(
  client$: GramCore,
  request?: GetMarketplaceSettingsRequest | undefined,
  security?: GetMarketplaceSettingsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<MarketplaceSettingsQueryData>;
} {
  return {
    queryKey: queryKeyMarketplaceSettings({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function marketplaceSettingsQueryFn(
      ctx,
    ): Promise<MarketplaceSettingsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(pluginsGetMarketplaceSettings(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyMarketplaceSettings(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "plugins", "getMarketplaceSettings", parameters];
}
